/**
 * Compost Guide — reading progress
 */
(function () {
  if (window.__compostGuideBooted) return;
  window.__compostGuideBooted = true;

  function initProgress() {
    var bar = document.querySelector('[data-cg-progress]');
    if (!bar) return;
    function update() {
      var h = document.documentElement;
      var scroll = h.scrollTop || document.body.scrollTop;
      var height = h.scrollHeight - h.clientHeight;
      var pct = height > 0 ? (scroll / height) * 100 : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProgress);
  } else {
    initProgress();
  }
})();
